import { render } from "./ResourcesUpload.vue?vue&type=template&id=94093e5e&scoped=true"
import script from "./ResourcesUpload.vue?vue&type=script&lang=js"
export * from "./ResourcesUpload.vue?vue&type=script&lang=js"

import "./ResourcesUpload.vue?vue&type=style&index=0&id=94093e5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94093e5e"]])

export default __exports__